export const govCertapplyConstants = {
  SCREEN_URL_LOAD_REQUEST: 'SCREEN_URL_LOAD_REQUEST',
  SCREEN_URL_LOAD_SUCCESS: 'SCREEN_URL_LOAD_SUCCESS',
  SCREEN_URL_LOAD_FAILURE: 'SCREEN_URL_LOAD_FAILURE',

  VERIFY_INDI_ECDW_LOAD_REQUEST: 'VERIFY_INDI_ECDW_LOAD_REQUEST',
  VERIFY_INDI_ECDW_LOAD_SUCCESS: 'VERIFY_INDI_ECDW_LOAD_SUCCESS',
  VERIFY_INDI_ECDW_LOAD_FAILURE: 'VERIFY_INDI_ECDW_LOAD_FAILURE',

  ISSUE_INDI_ECDW_LOAD_REQUEST: 'ISSUE_INDI_ECDW_LOAD_REQUEST',
  ISSUE_INDI_ECDW_LOAD_SUCCESS: 'ISSUE_INDI_ECDW_LOAD_SUCCESS',
  ISSUE_INDI_ECDW_LOAD_FAILURE: 'ISSUE_INDI_ECDW_LOAD_FAILURE',

  INQUIRE_INDI_ECDW_POPUP_LIST_LOAD_REQUEST: 'INQUIRE_INDI_ECDW_POPUP_LIST_LOAD_REQUEST',
  INQUIRE_INDI_ECDW_POPUP_LIST_LOAD_SUCCESS: 'INQUIRE_INDI_ECDW_POPUP_LIST_LOAD_SUCCESS',
  INQUIRE_INDI_ECDW_POPUP_LIST_LOAD_FAILURE: 'INQUIRE_INDI_ECDW_POPUP_LIST_LOAD_FAILURE',

  CHANGE_INDI_ECDW_INFO_LOAD_REQUEST: 'CHANGE_INDI_ECDW_INFO_LOAD_REQUEST',
  CHANGE_INDI_ECDW_INFO_LOAD_SUCCESS: 'CHANGE_INDI_ECDW_INFO_LOAD_SUCCESS',
  CHANGE_INDI_ECDW_INFO_LOAD_FAILURE: 'CHANGE_INDI_ECDW_INFO_LOAD_FAILURE',

  INQUIRE_INDI_STIP_AGREE_LOAD_REQUEST: 'INQUIRE_INDI_STIP_AGREE_LOAD_REQUEST',
  INQUIRE_INDI_STIP_AGREE_LOAD_SUCCESS: 'INQUIRE_INDI_STIP_AGREE_LOAD_SUCCESS',
  INQUIRE_INDI_STIP_AGREE_LOAD_FAILURE: 'INQUIRE_INDI_STIP_AGREE_LOAD_FAILURE',

  LOAD_REQUEST: 'APLY_SUPPORT_LOAD_REQUEST',
  LOAD_SUCCESS: 'APLY_SUPPORT_LOAD_SUCCESS',
  LOAD_FAILURE: 'APLY_SUPPORT_LOAD_FAILURE',

  INQUIRE_LOAD_REQUEST: 'APLY_INQUIRE_LOAD_REQUEST',
  INQUIRE_LOAD_SUCCESS: 'APLY_INQUIRE_LOAD_SUCCESS',
  INQUIRE_LOAD_FAILURE: 'APLY_INQUIRE_LOAD_FAILURE',
  // ECDApplyQFVerify
  ECD_APPLY_QF_VERIFY_LOAD_REQUEST: 'ECD_APPLY_QF_VERIFY_LOAD_REQUEST',
  ECD_APPLY_QF_VERIFY_LOAD_SUCCESS: 'ECD_APPLY_QF_VERIFY_LOAD_SUCCESS',
  ECD_APPLY_QF_VERIFY_LOAD_FAILURE: 'ECD_APPLY_QF_VERIFY_LOAD_FAILURE',
  // ECDApply
  ECD_APPLY_LOAD_REQUEST: 'ECD_APPLY_LOAD_REQUEST',
  ECD_APPLY_LOAD_SUCCESS: 'ECD_APPLY_LOAD_SUCCESS',
  ECD_APPLY_LOAD_FAILURE: 'ECD_APPLY_LOAD_FAILURE',

  SHOW_POPUP_ITEMS: 'SHOW_POPUP_ITEMS',
  CLOSE_POPUP_ITEMS: 'CLOSE_POPUP_ITEMS',
}
